import { Button, cn, ScrollArea } from "@eisox/design-system";
import { PencilIcon } from "@eisox/icons";

import { m } from "~/paraglide/messages";

import { isAssociationEdited, type EditableAirHandlerUnitRoomAssociation } from "../helpers/association.helper";

const NAME = "RoomAssociationList";

interface RoomAssociationListProps {
  associations: EditableAirHandlerUnitRoomAssociation[];
  selectedAssociationKey?: string;
  onSelect: (associationKey: string) => void;
}

const RoomAssociationList: React.FC<RoomAssociationListProps> = ({
  associations,
  selectedAssociationKey,
  onSelect,
}) => (
  <div className="gap-2.5 max-w-51.25 flex flex-1 flex-col text-base">
    <h3 className="font-semibold">{m.air_handler_unit_room_association_list_title()}</h3>
    <ScrollArea className="gap-1.25 flex w-full">
      {associations.map(association => {
        const edited = isAssociationEdited(association);

        return (
          <Button
            key={association.key}
            type="button"
            className={cn(
              "p-1.75 box-border flex w-full justify-between rounded-[5px] text-primary-dark-blue",
              selectedAssociationKey === association.key && "bg-primary-gray text-primary-blue",
            )}
            onClick={() => onSelect(association.key)}
          >
            {association.name}
            {edited && <PencilIcon />}
          </Button>
        );
      })}
    </ScrollArea>
  </div>
);

RoomAssociationList.displayName = NAME;

export { RoomAssociationList };
export type { RoomAssociationListProps };
